export default __webpack_public_path__ + "static/media/05_s.ddc8d20d.png";